import { render, staticRenderFns } from "./OrgEmployees.vue?vue&type=template&id=1ae4a4ce"
import script from "./OrgEmployees.vue?vue&type=script&lang=js"
export * from "./OrgEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports